import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PageLoading } from 'components/atoms/loading';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useGetExpenseAccess } from 'queries/expense-management/expense';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { NotFoundPage, ExpensesRoutes } from 'routes/vendor/lazy-imports';
const ExpenseRoutesLayout = ({ children })=>{
    const [isExpensesFeatureEnabled] = useAccountFeature(AccountFeature.Expenses);
    const { data: expenseAccess, isInitialLoading } = useGetExpenseAccess(undefined, undefined, {
        enabled: isExpensesFeatureEnabled
    });
    if (isInitialLoading) {
        return /*#__PURE__*/ _jsx(PageLoading, {});
    }
    // Feature should be enabled and user should have access to view expenses or approvals
    if (((expenseAccess === null || expenseAccess === void 0 ? void 0 : expenseAccess.canViewForMyself) || (expenseAccess === null || expenseAccess === void 0 ? void 0 : expenseAccess.canViewApprovals)) && isExpensesFeatureEnabled) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(NotFoundPage, {});
};
export const expenseRoutes = {
    path: `${ROUTE_PATHS.EXPENSES}/${ROUTE_PATHS.MATCH_ALL}`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(ExpenseRoutesLayout, {
            children: /*#__PURE__*/ _jsx(ExpensesRoutes, {})
        })
    })
};
